/**
 * Démonstration de la suppression d'un widget pour le tutoriel.
 * Reprend la vraie interaction : un curseur clique l'icône corbeille → un bouton
 * « Supprimer ? » apparaît → un 2e clic confirme → la carte disparaît en fondu,
 * puis réapparaît (boucle).
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WeatherWidget } from "../widgets/WeatherWidget";
import { WidgetPreviewContext } from "../widgets/WidgetShell";

export function DeleteDemo({ running }: { running: boolean }) {
  const cls = running ? "is-running" : "";

  return (
    <>
      {/* Carte qui disparaît en fondu (le bouton mock est dedans → il suit). */}
      <div className={`tutorial-delete-widget ${cls}`}>
        <WidgetPreviewContext.Provider value={true}>
          <WeatherWidget locationName="Lanester" />
        </WidgetPreviewContext.Provider>

        {/* Bouton corbeille qui se transforme en pastille « Supprimer ? ». */}
        <span className={`tutorial-delete-btn ${cls}`} aria-hidden="true">
          <FontAwesomeIcon
            icon="trash-can"
            className="tutorial-delete-btn-icon"
          />
          <span className="tutorial-delete-btn-label">Supprimer&nbsp;?</span>
        </span>
      </div>

      {/* Curseur qui maintient le bouton et suit la carte qui rétrécit. */}
      <div className={`tutorial-delete-cursor ${cls}`} aria-hidden="true">
        <span className="tutorial-cursor-ring" />
        <FontAwesomeIcon
          icon="arrow-pointer"
          className="tutorial-cursor-icon text-default-text"
        />
      </div>
    </>
  );
}
